import { makeStyles } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import isoCountries from "i18n-iso-countries";
import jwt_decode from "jwt-decode";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import CustomDateTimePicker from "../../components/CustomInputs/CustomDateTimePicker";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import ProfileContext from "../../components/ProfileContext";
import Toast from "../../components/ToastContainer/CustomToast";
import httpCommon from "../../config/http-common";
import { getListSettings } from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import { getCompanyInfo } from "../../slices/Company/CompanySlice";
import { listHost } from "../../slices/HostSlice";
import { createInvitation } from "../../slices/Invitations/InvitationsSlice";
import { listVisitorTypeZlink } from "../../slices/PurposeTypeUSA/PurposeTypeUSASlice";
import { getAllSites } from "../../slices/Site/SiteSlice";
import { getUserInfoPro } from "../../slices/User/UserSlice1";
import { getAllVisitorType } from "../../slices/VisitorType/VisitorTypeSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import CustomPhones from "../OnBoardV2/CustomPhones";
import "./customAutocomplete.css";

const useStyles = makeStyles((theme) => ({
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
}));

export default function CreateNewInvitation(props) {
  const { open } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [selectedHost, setSelectHost] = useState({});
  const [data, setData] = useState();
  const [hostList, setHostList] = useState([]);
  const [siteData, setSiteData] = useState([]);
  const [visitorData, setVisitorData] = useState([]);
  const [changeDate, setDateChange] = useState(true);
  const [userPhone, setUserPhone] = useState("");
  const { setCurrentTotalVisitCount } = useContext(ProfileContext);
  const [country, setCountry] = useState("");
  const [purposeTypeToggle, setPurposeTypeToggle] = useState("");
  const [visitorTypeToggle, setVisitorTypeToggle] = useState("");
  const [companyNameToggle, setCompanyNameToggle] = useState("");
  const [siteTypeToggle, setSiteTypeToggle] = useState("");
  const [purposeTypeMandatory, setPurposeTypeMandatory] = useState("");
  const [visitorTypeMandatory, setVisitorTypeMandatory] = useState("");
  const [companyNameMandatory, setCompanyNameMandatory] = useState("");
  const [siteTypeMandatory, setSiteTypeMandatory] = useState("");
  const [date, setDate] = useState(props.date);
  const { darkMode } = useContext(ThemeContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [siteTimeEnable, setSiteTimeEnable] = useState(true);
  const [siteCurrentDateTime, setSiteCurrentDateTime] = useState(null);

  var minutes =
    props.invitationIntervalTime === ""
      ? 30
      : Number(props.invitationIntervalTime);
  const [invitationIntervalTime, setInvitationIntervalTime] = useState(minutes);

  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  );

  var today = new Date();

  useEffect(() => {
    loadSetting();
  }, []);

  const loadSetting = () => {
    dispatch(getListSettings(""))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setInvitationIntervalTime(data.data.invitationIntervalTime);
          setDate(formatDate(data.data.dateFormat));
          setPurposeTypeToggle(data.data.invitationPurposeType);
          setVisitorTypeToggle(data.data.invitationVisitorType);
          setCompanyNameToggle(data.data.invitationCompanyName);
          setSiteTypeToggle(data.data.invitationSiteType);
          setPurposeTypeMandatory(data.data.checkInvitationPurposeType);
          setVisitorTypeMandatory(data.data.checkInvitationVisitorType);
          setCompanyNameMandatory(data.data.checkInvitationCompanyName);
          setSiteTypeMandatory(data.data.checkInvitationSiteType);
        }
      });
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  const config = {
    headers: { companyId: localStorage.getItem("companyId") },
  };

  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T" +
    (today.getHours() < 10 ? "0" + today.getHours() : today.getHours()) +
    ":" +
    (today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes());

  const [payload, setPayload] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    phoneNumber: "",
    phoneCountryCode: "",
    purposeTypeId: "",
    visitorTypeId: "",
    hostId: "",
    visitorCompanyName: "",
    siteId: "",
    scheduledStartDate: CommonUtil.formatLocalDateTime(startDate),
    scheduledEndDate: CommonUtil.formatLocalDateTime(
      moment(startDate).add(invitationIntervalTime, "minutes"),
    ),
    allowLateCheckOut: false,
    visitMode: "INVITATION",
    earlyCheckin: false,
    approvalReason: "",
    verifyTypeIn: "",
    walkInScan: "",
    invitationScan: "",
    selfScan: "",
    profilePhoto: "str.jpg",
  });

  const [phoneInput, setPhoneInput] = useState("");

  const [error, setError] = useState({
    firstName: false,
    lastName: false,
    emailId: false,
    phoneNumber: false,
    purposeTypeId: false,
    visitorTypeId: false,
    hostId: false,
    visitorCompanyName: false,
    siteId: false,
    selectedHost: false,
    profilePhoto: false,
    approvalReason: false,
  });

  const handleClose = () => {
    props.handleDialogClose();
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
    setError({
      [name]: false,
    });
  };

  useEffect(() => {
    loadData(props.open);
  }, []);

  const loadData = () => {
    loadVisitType();
    loadHosts();
    loadSites();
    loadVisitorType();
    loadUser();
    loadCompany();
  };

  const loadUser = () => {
    dispatch(getUserInfoPro(decoded_jwtToken.userId))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0000" || data.code === "UASI0033") {
          setUserPhone(data.data.phone);
        }
      })
      .catch((er) => {});
  };

  const loadVisitType = () => {
    const query = {
      id: "",
      name: "",
      status: "ACTIVE",
      pageNumber: 0,
      pageSize: 0,
      isPageable: true,
    };
    dispatch(listVisitorTypeZlink(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000" && data.data) {
          setData(data.data.purposeTypes);
          setDateChange(true);
        } else {
          setData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const loadVisitorType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getAllVisitorType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setVisitorData(data.data.visitorTypes);
        } else {
          setVisitorData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const loadHosts = () => {
    const payload = {
      pageNumber: 1,
      pageSize: 20,
      email: decoded_jwtToken.email,
    };
    dispatch(listHost(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "OMSI0000") {
          getSelectedItem(data.data.employees[0]);
          setHostList(data.data.employees);
        } else {
          getSelectedItem();
          setHostList([]);
        }
      });
  };

  const handleText = (event) => {
    httpCommon
      .unsecuredAxios()
      .get(
        "/web/selfRegistartion/employees/list?sort=createdAt%7Cdesc&caseSensitive=true&operator=OR&pageNumber=1&pageSize=0&firstName=" +
          event.target.value +
          "&lastName=" +
          event.target.value,
        config,
      )
      .then((data) => {
        if (data.data.code === "OMSI0000") {
          setHostList(data.data.data.employees);
        } else {
          getSelectedItem();
          setHostList([]);
        }
      });
  };

  const loadCompany = () => {
    dispatch(getCompanyInfo())
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0026")) {
          const fullCountryName = data.data.country;
          const countryCode = getCountryCodeFromName(fullCountryName);
          if (countryCode) {
            setCountry(countryCode);
          } else {
            setCountry("us");
          }
        }
      })
      .catch((er) => {});
  };
  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  const filterOptions = createFilterOptions({
    stringify: ({ firstName, email, lastName }) =>
      `${firstName} ${email} ${lastName}`,
    limit: 1,
  });

  const getSelectedItem = (newValue) => {
    if (newValue != null) {
      dispatch(getListSettings())
        .unwrap()
        .then((data) => {
          setPayload((prev) => ({
            ...prev,
            verifyTypeIn: data.data.invitationVerifyMode,
            invitationScan: data.data.invitationScanLimit,
            hostId: newValue.id,
          }));
        });
      setPayload((prev) => ({
        ...prev,
        hostId: newValue.id,
      }));
      setSelectHost(newValue);
    } else {
      setPayload((prev) => ({
        ...prev,
        hostId: "",
      }));
      setSelectHost({});
    }
  };

  const loadSites = () => {
    const query = {
      page: 1,
      rowsPerPage: 10000,
      name: "",
    };
    dispatch(getAllSites(query))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI0000") {
          setSiteData(data.data.site);
        } else {
          setSiteData([]);
        }
      });
  };

  useEffect(() => {
    if (siteData.length === 1) {
      const site = siteData[0];
      setPayload((prev) => ({
        ...prev,
        siteId: site,
        siteTimeZone: site.timeZone ? site.timeZone : "",
      }));
      setError((prev) => ({ ...prev, siteId: false }));
      getSiteCurrentDateTime(site.id);
    }
  }, [siteData, invitationIntervalTime]);

  const handleSumbit = () => {
    if (CommonUtil.isEmptyString(payload.firstName)) {
      Toast(t("USERPROFSCREEN007"), "error");
      setError({ firstName: true });
      return;
    }
    if (!CommonUtil.isValidNames(payload.firstName)) {
      Toast("Please Enter Valid First Name ", "error");
      setError({ firstName: true });
      return;
    }
    if (
      CommonUtil.isEmptyString(payload.emailId) &&
      CommonUtil.isEmptyString(payload.phoneNumber)
    ) {
      Toast(t("USERPROFSCREEN014"), "error");
      setError({ emailId: true });
      return;
    }
    if (
      decoded_jwtToken?.email === payload.emailId?.trim() ||
      payload.emailId?.trim() === selectedHost?.email
    ) {
      setError({ emailId: true });
      Toast(t("INVITATIONFORM006"), "error");
      return;
    }
    if (
      payload?.phoneNumber !== null &&
      payload?.phoneNumber !== undefined &&
      payload?.phoneNumber !== ""
    ) {
      if (
        userPhone === payload?.phoneCountryCode + "-" + payload?.phoneNumber ||
        payload?.phoneCountryCode + "-" + payload?.phoneNumber ===
          selectedHost?.phone
      ) {
        setError({ phoneNumber: false });
        Toast(t("INVITATIONFORM009"), "error");
        return;
      }
    }

    if (CommonUtil.isEmpty(selectedHost)) {
      Toast(t("INVITATIONFORM007"), "error");
      setError({ selectedHost: true });
      return;
    }

    if (CommonUtil.isEmpty(payload.siteId)) {
      Toast(t("Site is mandatory"), "error");
      setError({ selectedHost: true });
      return;
    }
    if (
      payload.scheduledStartDate === null ||
      payload.scheduledStartDate === undefined ||
      payload.scheduledStartDate === ""
    ) {
      setError({ scheduledStartDate: true });
      Toast(t("INVITATIONFORM011"), "error");
      return;
    }
    if (
      payload.scheduledEndDate === null ||
      payload.scheduledEndDate === undefined ||
      payload.scheduledEndDate === ""
    ) {
      setError({ scheduledEndDate: true });
      Toast(t("INVITATIONFORM012"), "error");
      return;
    }
    if (siteData.length > 1 && CommonUtil.isEmptyString(payload.siteId)) {
      setError({ siteId: true });
      Toast("Please select Site", "error");
      return;
    }
    if (
      new Date(payload.scheduledStartDate) < new Date() &&
      new Date(payload.scheduledStartDate) < new Date(payload.scheduledEndDate)
    ) {
      const dto = {
        firstName: !CommonUtil.isEmpty(payload.firstName)
          ? payload.firstName
          : undefined,
        lastName: !CommonUtil.isEmpty(payload.lastName)
          ? payload.lastName
          : undefined,
        purposeTypeId: payload.purposeTypeId.id,
        visitorTypeId: payload.visitorTypeId.id,
        hostId: payload.hostId,
        phoneCountryCode:
          !CommonUtil.isEmpty(payload.phoneCountryCode) &&
          !CommonUtil.isEmpty(payload.phoneNumber)
            ? payload.phoneCountryCode
            : undefined,
        phoneNumber: !CommonUtil.isEmpty(payload.phoneNumber)
          ? payload.phoneNumber
          : undefined,
        scheduledStartDate: CommonUtil.formatLocalDateTime(
          payload.scheduledStartDate,
        ),
        scheduledEndDate: CommonUtil.formatLocalDateTime(
          payload.scheduledEndDate,
        ),
        emailId: !CommonUtil.isEmpty(payload.emailId)
          ? payload.emailId
          : undefined,
        visitMode: payload.visitMode,
        verifyTypeIn: payload.verifyTypeIn,
        invitationScan: payload.invitationScan,
        walkInScan: payload.walkInScan,
        selfScan: payload.selfScan,
        visitorCompanyName: payload.visitorCompanyName,
        siteId: payload.siteId.id,
        approvalReason: payload.approvalReason,
        profilePhoto: payload.profilePhoto,
        siteTimeZone: payload.siteTimeZone,
      };

      dispatch(createInvitation(dto))
        .unwrap()
        .then((data) => {
          if (data.code === "CVAI0067") {
            Toast(t("INVSENTSUCCESS"), "success");
            setCurrentTotalVisitCount(data.data.currentVisitCount);
            props.loadData();
            handleClose();
          } else {
            onError(data);
          }
        });
    } else if (
      new Date(payload.scheduledStartDate) > new Date() &&
      new Date(payload.scheduledStartDate) < new Date(payload.scheduledEndDate)
    ) {
      const dto = {
        firstName: !CommonUtil.isEmpty(payload.firstName)
          ? payload.firstName
          : undefined,
        lastName: !CommonUtil.isEmpty(payload.lastName)
          ? payload.lastName
          : undefined,
        purposeTypeId: payload.purposeTypeId.id,
        visitorTypeId: payload.visitorTypeId.id,
        hostId: payload.hostId,
        phoneCountryCode: !CommonUtil.isEmpty(payload.phoneCountryCode)
          ? payload.phoneCountryCode
          : undefined,
        phoneNumber: !CommonUtil.isEmpty(payload.phoneNumber)
          ? payload.phoneNumber
          : undefined,
        scheduledStartDate: CommonUtil.formatLocalDateTime(
          payload.scheduledStartDate,
        ),
        scheduledEndDate: CommonUtil.formatLocalDateTime(
          payload.scheduledEndDate,
        ),
        emailId: !CommonUtil.isEmpty(payload.emailId)
          ? payload.emailId
          : undefined,
        profilePhoto: payload.profilePhoto,
        visitorCompanyName: payload.visitorCompanyName,
        siteId: payload.siteId.id,
        visitMode: payload.visitMode,
        siteTimeZone: payload.siteTimeZone,
      };
      dispatch(createInvitation(dto))
        .unwrap()
        .then((data) => {
          if (data.code === "CVAI0067" || data.code === "CVAI1007") {
            Toast(t("INVSENTSUCCESS"), "success");
            props.loadData();
            handleClose();
          } else {
            onError(data);
          }
        });
    } else {
      Toast(t("INVITATIONFORM003"), "error");
    }
  };

  const onError = (data) => {
    if (data)
      switch (data.code) {
        case "CVAE1015":
          setError({ emailId: true });
          break;
        case "CVAE1016":
          setError({ emailId: true });
          break;
        case "CVAE1012":
          setError({ firstName: true });
          break;
        case "CVAE1013":
          setError({ firstName: true });
          break;
        case "CVAE1017":
          setError({ phoneNumber: true });
          break;
        case "CVAE1041":
          setError({ purposeTypeId: true });
          break;
        case "CVAE1050":
          setError({ visitorTypeId: true });
          break;
        case "CVAE1051":
          setError({ visitorCompanyName: true });
          break;
        case "CVAE1019":
          setError({ hostId: true });
          break;
        case "CVAE1021":
          setError({ scheduledStartDate: true });
          break;
        case "CVAE1022":
          setError({ scheduledEndDate: true });
          break;
        case "CVAE1023":
          setError({ scheduledEndDate: true });
          break;
        case "CVAE0300":
          setError({ siteId: true });
          break;
        default:
          setError({ ...error });
      }
    Toast(data.message, "error");
  };

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setPhoneInput(value);
    setPayload({
      ...payload,
      phoneCountryCode: "+" + data.dialCode,
      phoneNumber: value.toString().replace(data.dialCode, ""),
    });
    setError({ phoneNumber: false });
  };

  const onselectVisitorType = (event) => {
    setPayload({
      ...payload,
      visitorTypeId: event,
    });
  };

  const onselectPurposeType = (event) => {
    setPayload({
      ...payload,
      purposeTypeId: event,
    });
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const handleOptionSelected = (event, value) => {
    if (value) {
      getSelectedItem(value);
      setSelectHost(value);
      setError({ selectedHost: false });
    } else {
      getSelectedItem(null);
      setSelectHost(null);
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setSearchTerm(newInputValue.replace(/\s\s+/g, " "));
  };

  const getSiteCurrentDateTime = (siteId) => {
    httpCommon
      .securedAxios() // swap for whatever instance you actually use for GETs — check what handleText() uses as reference
      .get(`/web/visit/site/${siteId}/currectDateTime`)
      .then((response) => {
        if (
          response?.data?.code === "CVAI0000" &&
          response.data.data?.siteCurrentTime
        ) {
          const startDate = new Date(response.data.data.siteCurrentTime);
          setPayload((prev) => ({
            ...prev,
            scheduledStartDate: CommonUtil.formatLocalDateTime(startDate),
            scheduledEndDate: CommonUtil.formatLocalDateTime(
              moment(startDate).add(invitationIntervalTime, "minutes"),
            ),
          }));
          setSiteCurrentDateTime(startDate);
          setSiteTimeEnable(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      PaperProps={{
        style: {
          borderRadius: "20px !important",
          minWidth: "50vw",
          backgroundColor: darkMode ? "rgb(14, 42, 65)" : "#fff",
          color: darkMode ? "#fff" : "#434547",
        },
      }}
      disableBackdropClick
      disableEscapeKeyDown
      BackdropProps={{
        style: {
          backdropFilter: "blur(5px)",
        },
      }}
    >
      <DialogTitle variant="h4">
        <Grid
          container
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Grid item>
            <Typography
              style={{
                color: darkMode ? "#fff" : "black",
                fontSize: "20px",
                fontWeight: "450",
              }}
            >
              {t("buttonVisitorInvitationNewInvite")}
            </Typography>
          </Grid>
          <Grid item>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon onClick={handleClose} />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <Divider
        variant="middle"
        style={{
          background: darkMode
            ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
            : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
          height: "1px",
          opacity: 0.5,
        }}
      />

      <DialogContent
        sx={{
          padding: "24px 10px 0px 24px",
        }}
      >
        <Grid
          container
          justifyContent="center"
          style={{ width: "100%" }}
          columnSpacing={2}
          rowSpacing={3}
        >
          <Grid item lg={6} sm={12}>
            <CustomTextfield
              label={t("USER0001")}
              error={error.firstName}
              name="firstName"
              value={payload.firstName}
              handleChange={(e) => handleChange(e)}
              helperText={error.firstName}
              required={true}
              autoComplete="off"
              // inputProps={{ className: classes.input }}
              InputProps={{
                style: {
                  color: darkMode ? "#fff" : "black",
                },
              }}
            />
          </Grid>

          <Grid item lg={6} sm={12}>
            <CustomTextfield
              label={t("USER0002")}
              error={error.lastName}
              name="lastName"
              value={payload.lastName}
              handleChange={(e) => handleChange(e)}
              helperText={error.lastName}
              autoComplete="off"
              InputProps={{
                style: {
                  color: darkMode ? "#fff" : "black",
                },
              }}
            />
          </Grid>

          <Grid item lg={6} sm={12}>
            <CustomTextfield
              label={t("VISUPDATE0001")}
              error={error.emailId}
              name="emailId"
              value={payload.emailId}
              handleChange={(e) => handleChange(e)}
              helperText={error.emailId}
              validation="email"
              autoComplete="off"
              InputProps={{
                style: {
                  color: darkMode ? "#fff" : "black",
                },
              }}
            />
          </Grid>

          <Grid item lg={6} xs={12}>
            <CustomPhones
              placeholder="Mobile"
              value={phoneInput}
              country={country}
              specialLabel={false}
              handleChange={(value, data, event, formattedValue) =>
                handlePhoneChange(value, data, event, formattedValue)
              }
            />
          </Grid>

          {purposeTypeToggle && (
            <Grid item lg={6} xs={12}>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                style={{ width: "100%" }}
                noOptionsText={"No Options found"}
                name="purposeTypeId"
                value={payload.purposeTypeId}
                options={CommonUtil.isEmptyArray(data) ? [] : data}
                getOptionLabel={(option) => (option.name ? option.name : "")}
                onChange={(event, newValue) => {
                  if (!CommonUtil.isEmpty(newValue)) {
                    onselectPurposeType(newValue);
                  } else {
                    onselectPurposeType("");
                  }
                  setError({ purposeTypeId: false });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required={purposeTypeMandatory ? true : false}
                    name="purposeTypeId"
                    value={payload.purposeTypeId}
                    error={error.purposeTypeId}
                    variant="outlined"
                    fullWidth
                    label={t("PURPOSELABEL1")}
                  />
                )}
              />
            </Grid>
          )}

          {visitorTypeToggle ? (
            <Grid item lg={6} xs={12}>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                style={{ width: "100%" }}
                noOptionsText={"No Options found"}
                name="visitorTypeId"
                value={payload.visitorTypeId}
                options={
                  CommonUtil.isEmptyArray(visitorData) ? [] : visitorData
                }
                getOptionLabel={(option) => (option.name ? option.name : "")}
                onChange={(event, newValue) => {
                  if (!CommonUtil.isEmpty(newValue)) {
                    onselectVisitorType(newValue);
                  } else {
                    onselectVisitorType("");
                  }
                  setError({ visitorTypeId: false });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required={visitorTypeMandatory ? true : false}
                    name="visitorTypeId"
                    value={payload.visitorTypeId}
                    error={error.visitorTypeId}
                    variant="outlined"
                    fullWidth
                    label={t("COMMON068")}
                  />
                )}
              />
            </Grid>
          ) : null}

          {companyNameToggle ? (
            <Grid item lg={6} sm={12}>
              <CustomTextfield
                label={t("VISUPDATE0006")}
                error={error.visitorCompanyName}
                name="visitorCompanyName"
                value={payload.visitorCompanyName}
                handleChange={(e) => handleChange(e)}
                helperText={error.visitorCompanyName}
                required={companyNameMandatory ? true : false}
                InputProps={{
                  style: {
                    color: darkMode ? "#fff" : "black",
                  },
                }}
              />
            </Grid>
          ) : null}

          <Grid item lg={6} sm={12}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              style={{ color: "#242424" }}
              id="host-autocomplete"
              freeSolo
              noOptionsText="No Options found"
              fullWidth
              filterOptions={filterOptions}
              options={hostList}
              value={selectedHost}
              inputValue={searchTerm}
              onChange={handleOptionSelected}
              onInputChange={handleInputChange}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              getOptionLabel={(option) => {
                if (!option) return "";
                if (typeof option === "string") return option;

                return option.lastName
                  ? `${option.firstName} ${option.lastName}`
                  : option.firstName || "";
              }}
              renderInput={(params) => (
                <CustomTextfield
                  {...params}
                  label={t("commonsTextFeildHost")}
                  placeholder={t("commonsTextFeildHost")}
                  error={error.selectedHost}
                  required
                />
              )}
            />
          </Grid>

          <Grid item lg={6} xs={12}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              sx={{ width: "100%" }}
              noOptionsText={"No Options found"}
              name="siteId"
              value={payload.siteId}
              disabled={siteData.length === 1}
              options={CommonUtil.isEmptyArray(siteData) ? [] : siteData}
              getOptionLabel={(option) => (option.name ? option.name : "")}
              onChange={(event, newValue) => {
                if (!CommonUtil.isEmpty(newValue)) {
                  setPayload((prev) => ({
                    ...prev,
                    siteId: newValue,
                    siteTimeZone: newValue.timeZone ? newValue.timeZone : "",
                  }));

                  getSiteCurrentDateTime(newValue.id);
                } else {
                  setPayload((prev) => ({
                    ...prev,
                    siteId: "",
                    siteTimeZone: "",
                    scheduledStartDate: null,
                    scheduledEndDate: null,
                  }));

                  setSiteTimeEnable(true);
                  setSiteCurrentDateTime(null);
                }

                setError((prev) => ({
                  ...prev,
                  siteId: false,
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="siteId"
                  required={true}
                  error={error.siteId}
                  variant="outlined"
                  fullWidth
                  label={t("SITE013")}
                />
              )}
            />
          </Grid>

          {/* {siteTypeToggle && (
            <Grid item xs={12}>
              <Typography
                variant="caption"
                style={{ color: darkMode ? "#9aa5b1" : "#6b7280" }}
              >
                {siteTimeEnable
                  ? t(
                      "Select a site above to enable the start and end date & time — they will be pre-filled with that site's current local time.",
                    )
                  : t(
                      "Start and end date & time are shown in the selected site's local time zone.",
                    )}
              </Typography>
            </Grid>
          )} */}

          <Grid item lg={6} xs={12}>
            <CustomDateTimePicker
              onChange={(scheduledStartDate) =>
                setPayload((prev) => ({
                  ...prev,
                  scheduledStartDate: CommonUtil.formatLocalDateTime(
                    scheduledStartDate,
                  ),
                  scheduledEndDate: CommonUtil.formatLocalDateTime(
                    moment(scheduledStartDate).add(
                      invitationIntervalTime,
                      "minutes",
                    ),
                  ),
                }))
              }
              minDateTime={siteCurrentDateTime}
              value={payload.scheduledStartDate}
              label={t("INVITESTARTDATEERROR1")}
              changeDate={changeDate}
              date={date}
              disabled={siteTimeEnable}
            />
          </Grid>
          <Grid item lg={6} xs={12}>
            <CustomDateTimePicker
              onChange={(scheduledEndDate) =>
                setPayload((prev) => ({
                  ...prev,
                  scheduledEndDate: CommonUtil.formatLocalDateTime(
                    scheduledEndDate,
                  ),
                }))
              }
              minDateTime={
                payload.scheduledStartDate
                  ? new Date(payload.scheduledStartDate)
                  : undefined
              }
              value={payload.scheduledEndDate}
              label={t("INVITESTARTDATEERROR2")}
              changeDate={changeDate}
              date={date}
              disabled={siteTimeEnable}
            />
          </Grid>
          <Grid
            item
            lg={
              (Number(!purposeTypeToggle) +
                Number(!visitorTypeToggle) +
                Number(!companyNameToggle) +
                Number(!siteTypeToggle)) %
                2 ===
              1
                ? 12
                : 6
            }
            sm={12}
          >
            <CustomTextfield
              label={t("COMMON016")}
              error={error.approvalReason}
              name="approvalReason"
              value={payload.approvalReason}
              validation="restrictLength"
              handleChange={(e) => handleChange(e)}
              helperText={error.approvalReason}
              style={{ marginTop: "0px" }}
              InputProps={{
                style: {
                  color: darkMode ? "#fff" : "black",
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: "center",
        }}
      >
        <CancelButtons
          variant="contained"
          color="secondary"
          onClick={handleClose}
        >
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {t("COMMON008")}
          </Typography>
        </CancelButtons>
        <SubmitButtons variant="contained" onClick={handleSumbit}>
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {t("COMMON007")}
          </Typography>
        </SubmitButtons>
      </DialogActions>
    </Dialog>
  );
}
